"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = forOwn;

function forOwn(obj, callback) {
  var keys = Object.keys(obj);
  var l = keys.length;
  var i = 0;
  var key;

  while (i < l) {
    key = keys[i];
    i += 1;
    callback(obj[key], key);
  }
}
//# sourceMappingURL=forown.js.map